/**
 * @namespace ThemeEvents
 * @description Theme-specific events for cross-component UI coordination.
 */
export class ThemeEvents {
  /** @static @constant {string} Event triggered when quantity-selector value changes */
  static quantitySelectorUpdate = 'quantity-selector:update';
}

/**
 * Event class for quantity-selector updates.
 * @extends {Event}
 */
export class QuantitySelectorUpdateEvent extends Event {
  /**
   * @param {number} quantity
   * @param {number} [cartLine] The id of the updated cart line
   */
  constructor(quantity, cartLine) {
    super(ThemeEvents.quantitySelectorUpdate, { bubbles: true });
    this.detail = { quantity, cartLine };
  }
}

/** @typedef {typeof ThemeEvent} ThemeEventType */

export const ThemeEvent = {
  WishlistChanged: 'wishlist:changed',
  WishlistRefresh: 'wishlist:refresh',
};

/**
 * Notify listeners that wishlist button DOM was injected (e.g. lazy quick-view).
 */
export function dispatchWishlistRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ThemeEvent.WishlistRefresh));
}
